import { GetCallSaleStatus_Enum } from "../passenger/enums";

//#region TerminalType
export enum TerminalType_Enum {
  Driver = 0,
  Counter = 1,
  Kiosk = 2,
  PassengerApp = 3,
  Company = 4,
  Pos = 5,
  Offline = 6,
  CallSale = 7,
  Panel = 8,
}

export const TerminalType_Display: { [index: number]: string } = {
  [TerminalType_Enum.Driver]: "راننده ",
  [TerminalType_Enum.Counter]: "کانتر ",
  [TerminalType_Enum.Kiosk]: "کیوسک",
  [TerminalType_Enum.PassengerApp]: "اپلیکیشن",
  [TerminalType_Enum.Company]: "شرکت",
  [TerminalType_Enum.Pos]: "Pos",
  [TerminalType_Enum.Offline]: "آفلاین",
  [TerminalType_Enum.CallSale]: "تلفنی",
};

//#endregion

//#region TransactionType
export enum TransactionType_Enum {
  DriverCharge = 1,
  TripRequest = 2,
}

export const TransactionType_Display: { [index: number]: string } = {
  [TransactionType_Enum.DriverCharge]: "شارژ راننده",
  [TransactionType_Enum.TripRequest]: "کیوسک",
};

//#endregion

//#region VehiclePlaqueType
export enum VehiclePlaqueType_Enum {
  personal = 0,
  old = 1,
  taxi = 2,
  agriculture = 3,
  governmental = 4,
  police = 5,
  transportation = 6,
  temporary = 7,
  motor = 8,
  historical = 9,
  formality = 10,
  political = 11,
  disabledPeople = 12,
  freeZone = 13,
  suburbanTaxi = 14,
}

export const VehiclePlaqueType_Dispaly: { [index: number]: string } = {
  [VehiclePlaqueType_Enum.personal]: "شخصی",
  [VehiclePlaqueType_Enum.old]: "قدیمی",
  [VehiclePlaqueType_Enum.taxi]: "تاکسی",
  [VehiclePlaqueType_Enum.agriculture]: "کشاورزی",
  [VehiclePlaqueType_Enum.governmental]: "دولتی",
  [VehiclePlaqueType_Enum.police]: "پلیس",
  [VehiclePlaqueType_Enum.transportation]: "حمل و نقل عمومی",
  [VehiclePlaqueType_Enum.temporary]: "گذر موقت",
  [VehiclePlaqueType_Enum.motor]: "موتور",
  [VehiclePlaqueType_Enum.historical]: "تاریخی",
  [VehiclePlaqueType_Enum.formality]: "تشریفات",
  [VehiclePlaqueType_Enum.political]: "سیاسی",
  [VehiclePlaqueType_Enum.disabledPeople]: "معلولین",
  [VehiclePlaqueType_Enum.freeZone]: "منطقه ازاد",
  [VehiclePlaqueType_Enum.suburbanTaxi]: "تاکسی برون شهری ",
};
//#endregion

//#region SalePaymentMethod
export enum SalePaymentMethod_Enum {
  cashToSeller = 1,
  cashToDriver = 2,
  androidPos = 3,
  link = 4,
  cashToCompany = 5,
  wallet = 6,
  //Pc Pose
  pCPos = 7,
  organisationCredit = 8,
}

export const SalePaymentMethod_Dispaly: { [index: number]: string } = {
  [SalePaymentMethod_Enum.cashToSeller]: "نقدی به فروشنده",
  [SalePaymentMethod_Enum.cashToDriver]: "نقدی به راننده",
  [SalePaymentMethod_Enum.androidPos]: "اندروید پوز ",
  [SalePaymentMethod_Enum.link]: "لینک پرداخت ",
  [SalePaymentMethod_Enum.cashToCompany]: "نقدی به شرکت ",
  [SalePaymentMethod_Enum.wallet]: "اعتباری",
  [SalePaymentMethod_Enum.pCPos]: "پوز",
  [SalePaymentMethod_Enum.organisationCredit]: "کسر از اعتبار سازمان",
};
//#endregion

//#region TripOptionType
export enum TripOptionType_Enum {
  ExtraDestination = 1,
  StopMinute = 2,
  ExtraBaggage = 3,
  BaggageTransportaion = 4,
}

export const TripOptionType_Display: { [index: number]: string } = {
  [TripOptionType_Enum.ExtraDestination]: "مقصد اضافه",
  [TripOptionType_Enum.StopMinute]: "توقف",
  [TripOptionType_Enum.ExtraBaggage]: "چمدان اضافه",
  [TripOptionType_Enum.BaggageTransportaion]: "حمل چمدان",
};
//#endregion

//#region TripOptionStatus
export enum TripOptionStatus_Enum {
  NotRegistered = 0,
  Pending = 1,
  Approved = 2,
  PassengerDeleted = 4,
  TemporaryRegistration = 5,
}

export const TripOptionStatus_Display: { [index: number]: string } = {
  [TripOptionStatus_Enum.NotRegistered]: "ثبت نشده",
  [TripOptionStatus_Enum.Pending]: "در انتظار تایید راننده",
  [TripOptionStatus_Enum.Approved]: "تایید شده",
  [TripOptionStatus_Enum.PassengerDeleted]: "توسط مسافر",
  [TripOptionStatus_Enum.TemporaryRegistration]: "ثبت موقت",
};
//#endregion

//#region TransportType
export enum TransportType_Enum {
  Terminal = 0,
  Patrol = 1,
}

export const TransportType_Display: { [index: number]: string } = {
  [TransportType_Enum.Terminal]: "ترمینالی",
  [TransportType_Enum.Patrol]: "گردشی",
};
// #endregion

//#region PaymentStep
export enum PaymentStep_Enum {
  ReSend = 1,
  PendingPrint = 2,
  RePrint = 3,
  PendingCard = 4,
  PendingFinalizing = 5,
  Success = 6,
  RePay = 7,
  ErrorFinalizing = 8,
}

export const PaymentStep_Display: { [index: number]: string } = {
  [PaymentStep_Enum.ReSend]: "ثبت درخواست مجدد",
  [PaymentStep_Enum.PendingPrint]: "در انتظار پرینت",
  [PaymentStep_Enum.RePrint]: "پرینت مجدد",
  [PaymentStep_Enum.PendingCard]: "در کشیدن کارت",
  [PaymentStep_Enum.PendingFinalizing]: "در انتظار نهایی سازی پرداخت",
  [PaymentStep_Enum.Success]: "سفر موفق ثبت شده",
  [PaymentStep_Enum.RePay]: "پرداخت مجدد",
  [PaymentStep_Enum.ErrorFinalizing]: "نهایی سازی مجدد",
};

// #endregion

//#region AreaLimitType
export enum AreaLimitType_Enum {
  InCity = 1,
  OutCity = 2,
}

export const AreaLimitType_Display: { [index: number]: string } = {
  [AreaLimitType_Enum.InCity]: "درون شهری",
  [AreaLimitType_Enum.OutCity]: "بین شهری",
};

// #endregion

// Positive and Negetive parameters
export enum Taxi_SurveyParameterType {
  Positive = 1,
  Negative = 2,
}

export enum NotifyMode_Enum {
  message = 1,
  notify = 2,
  warning = 3,
}
export enum NotifyFor_Enum {
  vehicle = 1,
  personal = 2,
}

export enum POSType_Enum {
  //به پرداخت ملت
  Beh_Pardakht = 1,

  //سپهر
  Sepehr = 0,
}

//This enum is for signalr
export enum Hub_EventType_Enum {
  //لغو سفر توسط راننده --- برای مسافر
  DriverTripCanceled = 1,

  //لغو سفر توسط مسافر----- برای راننده
  PassengerTripCanceled = 2,

  //تغییر وضعیت راننده ترمینالی ----- برای راننده
  TurningStatusChanged = 3,

  //قبول سفر------ برای مسافر
  AssignTrip = 4,

  //آپدیت گزینه‌های سفر توسط مسافر---- برای راننده و مسافر
  PendingTripOptionsChanged = 5,

  //نظرسنجی بعد سفر----- برای مسافر
  TripSurvey = 6,

  //گیت ورود-----برای راننده
  EntranceGate = 7,

  //گیت خروج---- برای و مسافر
  ExitGate = 8,

  //فراخوان--------برای راننده
  Summon = 9,

  //افلاین--------برای راننده
  Offline = 10,

  //به مبدا رسیدم ------ برای مسافر
  GetToSource = 11,

  //شروع سفر ------ برای مسافر
  StartTrip = 12,

  //حذف همه گزینه های اضافه شده یا تغییر دادده شده توسط مسافر  ------ برای راننده
  DeleteAllPendingTripOptions = 13,

  // حذف سفر قبول شده توسط راننده دیگر----------- برای راننده
  RemoveAcceptedSuggestion = 14,

  //تغییر روش پرداخت توسط مسافر----------- برای راننده
  ChangePaymentMethod = 15,
  // اتمام زمان حضور در دپو ---------- برای راننده
  ExpireAttendanceTime = 16,
  // check-in کردن راننده ---------- برای راننده
  CheckInDriver = 17,
}

// #region TripType
export enum TripType_Enum {
  Turn = 1,
  Exclusive = 2,
  Patrol = 3,
  Pickup = 4,
}

export const TripType_Display: { [index: number]: string } = {
  [TripType_Enum.Turn]: "نوبتی",
  [TripType_Enum.Exclusive]: "اختصاصی",
  [TripType_Enum.Patrol]: "گردشی",
  [TripType_Enum.Pickup]: "Pickup",
};
// #endregion

// #region TripType
export enum SaleReportaggregateFilter_Enum {
  TripTypeTerminal = 1,
  Day = 2,
}

export const SaleReportaggregateFilter_Display: { [index: number]: string } = {
  [SaleReportaggregateFilter_Enum.TripTypeTerminal]: "نوع سفر+ترمینال",
  [SaleReportaggregateFilter_Enum.Day]: "روز",
};
// #endregion

//#region TripStatus

export const TripStatusDriver_Display: { [index: number]: string } = {
  [GetCallSaleStatus_Enum.Registered]: "ثبت شده",
  [GetCallSaleStatus_Enum.InStation]: "در سکو",
  [GetCallSaleStatus_Enum.InMission]: "در حال سفر",
  [GetCallSaleStatus_Enum.EndMission]: "پایان سفر",
  [GetCallSaleStatus_Enum.Cancel]: "لغو",
  [GetCallSaleStatus_Enum.GetToSource]: "تاکسی رسید  ",
  [GetCallSaleStatus_Enum.AcceptTrip]: "اعزام راننده",
  [GetCallSaleStatus_Enum.AcceptReserve]: "تایید راننده » رزرو اولیه",
  [GetCallSaleStatus_Enum.MoveToPassenger]: "راننده به سوی شما حرکت کرد",
  [GetCallSaleStatus_Enum.EnterToThePassengerPool]: "درج سالن مسافر",
  [GetCallSaleStatus_Enum.AutoSearchForDriver]: "جستجو راننده",
  [GetCallSaleStatus_Enum.FinalAcceptTrip]: "تایید راننده » رزرو نهایی",
  [GetCallSaleStatus_Enum.PendingToPassengerPool]:
    "درانتظار ورود به سالن مسافر",
  [GetCallSaleStatus_Enum.Accepted]: "تایید راننده",
};
//#endregion

//#region PlaqueStatus
export enum PlaqueStatus_Enum {
  HasPlaque = 0,
  NoPlaque = 1,
}

export const PlaqueStatus_Display: { [index: number]: string } = {
  [PlaqueStatus_Enum.HasPlaque]: "دارای پلاک",
  [PlaqueStatus_Enum.NoPlaque]: "فاقد پلاک",
};

//#endregion

//#region VehicleWorkType
export enum VehicleWorkType_Enum {
  TravelledDistance = 1,
  WorkingHours = 2,
}

export const VehicleWorkType_Display: { [index: number]: string } = {
  [VehicleWorkType_Enum.TravelledDistance]: "کیلومتری",
  [VehicleWorkType_Enum.WorkingHours]: "ساعتی",
};

//#endregion

//#region VehicleStatusType
export enum VehicleStatusType_Enum {
  InService = 1,
  OutOfService = 2,
  InRepair = 3,
  InScrap = 4,
  InAuction = 5,
}

export const VehicleStatusType_Display: { [index: number]: string } = {
  [VehicleStatusType_Enum.InService]: "آماده برای سرویس",
  [VehicleStatusType_Enum.OutOfService]: "خارج از سرویس",
  [VehicleStatusType_Enum.InRepair]: "در حال تعمیر",
  [VehicleStatusType_Enum.InScrap]: "VehicleScrap",
  [VehicleStatusType_Enum.InAuction]: "مزایده",
};
// #endregion

//#region VehicleStatusTypes
export enum ManagementRole_Enum {
  transportationCompanyManagement = 1,
  tripManagement = 2,
}

export const ManagementRole_Display: { [index: number]: string } = {
  [ManagementRole_Enum.transportationCompanyManagement]:
    "مدیریت پیمانکار حمل و نقل",
  [ManagementRole_Enum.tripManagement]: "مدیریت سفر",
};
// #endregion
